export default "__VITE_ASSET__Dk$BuK0L__"